import TableWrap from "../Common/Table/Table";

import React from "react";
// import moment from "moment";
import { Button, Dropdown, Menu, message, Typography, Modal } from 'antd';
import "./report.css";
import DropdownIcon from "../../assets/icons/dropdown_icon.png";
import BaseCurrency from '../Common/BaseCurrency';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteExpense, expenses_delete } from '../../actions/expenses/expenses';
import { useTranslation } from "react-i18next";
import moment from "moment";

message.config({
  maxCount: 3,
});
const Text = Typography.Text


const ReportAdvances = (props) => {
  const history = useHistory()
  const [expenseSelectedData, setExpensesSelectedData] = React.useState("");
  const is_admin = useSelector((state) => state?.auth?.localVariables?.is_admin);

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const deleteExpResponse = useSelector(
    (state) => state.reports.deleteExpense || {}
  );
  const dispatch = useDispatch()
  const { t } = useTranslation();

  console.log(props,"propsDetaials==");


  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      deleteExpResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch({
        type: DeleteExpense.RESET
      })
      props.callExpenseDetails()
    } else {
      if (res_message) {
        dispatch({
          type: DeleteExpense.RESET
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteExpResponse]);

  const columns = [
    {
      title: t('advance_id'),
      dataIndex: "advance_number",
      key: "advance_number",
    },
    {
      title: t('date_time'),
      dataIndex: "date",
      key: "date",
      render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
    },
    {
      title: t('recorded_by'),
      dataIndex: "submitted_by",
      key: "submitted_by",
      render: (text) => <div>{text.name}</div>,
    },
    {
      title: t('reference'),
      dataIndex: "reference_no",
      key: "reference_no",
    },
    {
      title: t('Amount'),
      dataIndex: "amount_cents",
      key: "amount_cents",
      render: (text) => <div><BaseCurrency /> {text}</div>,
    },
    {
      title: t('status'),
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <div className={`status status_${text}`}>{text?.replace(/_/g, " ")}</div>
      ),
    },
    props.isUnlink ? {
      title: "",
      dataIndex: "id",
      key: "id",
      render: (text, record) => {
        return props.reportStatus === "unsubmitted" ||
          props.reportStatus === "rejected" ? (
          <Dropdown overlay={menu(record)} placement="bottomRight">
            <img src={DropdownIcon} alt={"logo"} className="action-logo" />
          </Dropdown>
        ) : null;
      },
    } : {},
  ];

  const menu = (record) => (
    <Menu onClick={(e) => {
      e.domEvent.stopPropagation()
      handleMenuClick(e, record)
    }}>
      <Menu.Item key="1">
        {t('unlink_advances')}
      </Menu.Item>
    </Menu>
  );

  const renderDelete = () => {
    return (
      <>
        <Text>{t('unlink_advance')}</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          disabled={deleteExpResponse?.loading}
          onClick={() => {
            dispatch(
              expenses_delete({
                advance_ids: [expenseSelectedData],
                params: { module_type: "REPORT" },
                unlink: true,
                advance: true,
              })
            );
          }
          }
        >
          {t('unlink')}
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => {
            setIsModalVisible(false)
            setExpensesSelectedData("")
          }}
        >
          {t('cancel')}
        </Button>
      </>
    );
  };

  function handleMenuClick(e, record) {
    switch (e.key) {
      case '1':
        setIsModalVisible(true)
        setExpensesSelectedData(record.id)
        break;
      case '2':
        // setReasonValue('')
        break;
      default:
    }
  }

  return (
    <div className="expenses-table">
      <Modal
        title={
          "Unlink Advance"
        }
        visible={isModalVisible}
        onCancel={() => {
          setExpensesSelectedData("")
          setIsModalVisible(false)
        }}
        footer={[]}
        className="center-aligned-modal"
      >
        {renderDelete()}
      </Modal>
      <TableWrap
        columns={columns} data={props.reportsAdvanceData}
        pagination={false}
        handleRowClick={(evt, record) => {
          evt.preventDefault();
          if (record) {
            history.push({
              pathname: `/expenses/advance-details/${record.id}`,
              state: { advanceData: record, user: props.user },
            });
          }
        }} />
    </div>
  );
};

export default ReportAdvances;
